import { useEffect, useState } from 'react'

import { Segment, Input, Icon, Grid, Loader,Button } from 'semantic-ui-react'
import { getTiposEstudio,deleteTipoEstudio } from '../../../../api/Orion/tipoEstudio';
import { ModalBasic,PaginationTable } from '../../../../components/Common';
import { useHistory } from "react-router-dom";
import { ListadoTiposEstudio }from '../../../../components/Admin/Orion';
import { HeaderPage } from '../../../../components/Admin';
import { toast } from 'react-toastify'
import "./AbmAdmin.scss"
import { getPermissions } from '../../../../components/Common';
import { useAuth } from '../../../../hooks';
import { animateScroll as scroll } from 'react-scroll'

export  function TipoEstudioOrionList() {
	const {auth} = useAuth()
    const [tiposEstudio,setTiposEstudio] = useState([])
    const [loading,setLoading] = useState(true)
    const [showModal,setShowModal] = useState(false)
    const [titleModal,setTitleModal] = useState(null)
    const [dataModal,setDataModal] = useState(null)
    const [contentModal,setContentModal] = useState(null)
    const [refetch, setRefetch] = useState(false)
	const [activePage, setActivePage] = useState(1);
	const [countPage, setCountPage] = useState(1);
	const [searchActive, setSearchActive] = useState("");
	
	const limitPagination = 10
    const history = useHistory()
	const fetchTiposEstudio = async (request = null) =>{
		
		const tiposEstudio = await getTiposEstudio(request)

		setTiposEstudio(tiposEstudio.results)
		setCountPage(tiposEstudio.count)
		setLoading(false)
		
	} 
    useEffect(()=>{
		scroll.scrollToTop();
		let searchExistentes = sessionStorage.getItem('orion_tipos_estudio_search');
		if(searchExistentes){
			setSearchActive(searchExistentes);
			fetchTiposEstudio(`page=1&paginate=true&search=${searchExistentes}`);
		} else {
			fetchTiposEstudio(`page=1&paginate=true`); 
		}
    },[refetch])
	
    const onRefetch = () => setRefetch((prev) => !prev);
	const openCloseModal = ()=>{
		
		setShowModal((prev)=>!prev)
	}
   	const onDeleteTipoEstudio =  async(tipoEstudio)=>{
		setContentModal(<p>Desea eliminar el tipo de estudio {tipoEstudio.long_name} ?</p>)
		setTitleModal("Eliminar tipo cobertura")
		setShowModal(true)
		setDataModal(tipoEstudio.id)
    

  	}
  	const openConfirmModal = async(id)=>{
		try {
			let response = await deleteTipoEstudio(id)
		
			toast.success(response.data)
			setShowModal(false)
			onRefetch()
		} catch (error) {
			console.error("Error en TipoEstudioOrionList:", error)
		} 
  	}
  	const crearTipoEstudio = (id) => {
    	history.push(`/admin/tipo_estudio_orion/crear`);
  	}

  	const onEditTipoEstudio = (tipoEstudio) => {
		history.push(`/admin/tipo_estudio_orion/edit/id/${tipoEstudio.id}`);
  	}
	const onShowTipoEstudio = (tipoEstudio) => {
		history.push(`/admin/tipo_estudio_orion/show/id/${tipoEstudio.id}`);
  	}
	


  	const onSearch =  (e) => {
		const value = e.target.value;
		setSearchActive(value);
		sessionStorage.setItem('orion_tipos_estudio_search', value);
		fetchTiposEstudio(`page=1&paginate=true&search=${value}`);
		setActivePage(1);
  	}
  	const onChange = (e, pageInfo) => {
		let request = `page=${pageInfo.activePage.toString()}&paginate=true`;
		if(searchActive !== "") request += `&search=${searchActive}`;
    	fetchTiposEstudio(request); 

		setActivePage(pageInfo.activePage);
		
	};
  return (
    <div>
		
		<HeaderPage title="Tipos de estudio" btnTitle="Agregar tipo de estudio" btnClick={crearTipoEstudio} permitionName="add_tipoestudio"/>
		
		
		   <Grid as={Segment} className='segment_search'>
				<Grid.Row >
					<Grid.Column computer={3} mobile={16} tablet={16}>  
						<Input 
							fluid
							
						icon={<Icon name='search' className='color_search' inverted circular />} 
						className="input_search"  
						inverted 
						placeholder='Buscar...' 
						value={searchActive}
						onChange={onSearch}
					/>
					</Grid.Column>
					<Grid.Column computer={11} mobile={16} tablet={16}>


					</Grid.Column>
					<br></br>
					<Grid.Column computer={2} mobile={16} tablet={16}>
					{getPermissions("add_tipoestudio",auth) && (
						<Button circular basic positive onClick={crearTipoEstudio}>
							Agregar tipo estudio
						</Button>
            )}
					</Grid.Column>

			
			
			</Grid.Row>
			</Grid>
		   
      <Grid>
        <Grid.Row>
          <Grid.Column computer={16}>
        
          </Grid.Column>
        </Grid.Row>
      </Grid>

	  {loading ? (
		<Loader active inline="centered">
			Cargando...
		</Loader>
	  ):(
		<ListadoTiposEstudio 
      tiposEstudio={tiposEstudio} 
      onDeleteTipoEstudio={onDeleteTipoEstudio}
      onEditTipoEstudio={onEditTipoEstudio}
      onShowTipoEstudio={onShowTipoEstudio}
	  countPage={countPage}
	  pagination={<PaginationTable 
		tiposEstudio={tiposEstudio} 
		onChange={onChange}
		activePage={activePage}
		countPage={countPage}
		
		limitPagination={limitPagination}
		/>}
    />
  		)}

      <ModalBasic 
      show={showModal} 
      size="small" 
      title={titleModal} 
      children={contentModal}
      onClose={openCloseModal}
      onConfirm={openConfirmModal}
	  dataModal={dataModal}
      />
    </div>
  )
}
